import * as actionTypes from "../actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  allConversations: null,
  currentConversation: null,
  currentConversationId: null,
  currentConversationAdvertId: null,
  chatFiles:null,
  error: null,
  loading: false,
  messageId: null,  
};

// --------- All conversation --------- //
const getAllConversationsStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const getAllConversationsSuccess = (state: any, action: any) => {
  return updateObject(state, {
    allConversations: action.allConversations,
    error: null,
    loading: false,
  });
};

const getAllConversationsFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// --------- current conversation --------- //
const getCurrentConversationStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const getCurrentConversationSuccess = (state: any, action: any) => {
  return updateObject(state, 
    action.isLatestMessage ? /* true if the message received from the chat socket */
    {
      currentConversation: {
          ...state.currentConversation,
          items: [action?.currentConversations, ...(state.currentConversation?.items || [])],
          
          online : false, /* Update the code later, when we get the "online status" in the socket response or by any new API. */
          totalSize: (state.currentConversation?.totalSize || 0) + 1,
        },
    }
    :
    {
      currentConversation: (state.currentConversation && action?.currentConversations) ? {
        ...action?.currentConversations,
        items: [...state.currentConversation?.items, ...action?.currentConversations?.items,],
      } : action?.currentConversations,
      error: null,
      loading: false,
    }
  );
};

const getCurrentConversationFailed = (state: any, action: any) => {
  return updateObject(state, {
    currentConversation: null,
    error: action.error,
    loading: false,
  });
};

const setCurrentConversation = (state: any, action: any) => {
  return updateObject(state, {
    currentConversation: null,
    error: null,
    loading: false,
  });
}

const updateCurrentConversationId = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    currentConversationId: action.conversationId,
  });
};

const updateCurrentConversationAdvertId = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    currentConversationAdvertId: action.advertId,
  });
};

// --------- Delete conversation --------- //

const deleteConversationStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const deleteConversationSuccess = (state: any, action: any) => {
  return updateObject(state, {
    error: null,
    loading: false,
    currentConversation: null,
    currentConversationId: null,
    currentConversationAdvertId: null,
  });
};

const deleteConversationFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// --------- Send message --------- //

const sendMessageStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const sendMessageSuccess = (state: any, action: any) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};

const sendMessageFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// --------- Get the files in the chat--------- //

const getChatFileStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const getChatFileSuccess = (state: any, action: any) => {
  const {id, data} = action.data;
  return updateObject(state, {
    chatFiles: state.chatFiles ? {...state.chatFiles, [id]: data} : {[id]: data},
    error: null,
    loading: false,
  });
};

const getChatFileFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// Message Id controller 
const setMessageId = (state: any, action: any) => {
  return updateObject(state, {
    messageId: action.messageId,
  });
}

const clearMessageId = (state: any) => {
  return updateObject(state, {
    messageId: null,
  });
}

const chatsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.ALL_CONVERSATIONS_START:
      return getAllConversationsStart(state);
    case actionTypes.ALL_CONVERSATIONS_SUCCESS:
      return getAllConversationsSuccess(state, action);
    case actionTypes.ALL_CONVERSATIONS_FAIL:
      return getAllConversationsFailed(state, action);
    case actionTypes.CURRENT_CONVERSATIONS_START:
      return getCurrentConversationStart(state);
    case actionTypes.CURRENT_CONVERSATIONS_SUCCESS:
      return getCurrentConversationSuccess(state, action);
    case actionTypes.CURRENT_CONVERSATIONS_FAIL:
      return getCurrentConversationFailed(state, action);
    case actionTypes.SET_CURRENT_CONVERSATIONS:
      return setCurrentConversation(state,action);
    case actionTypes.UPDATE_CURRENT_CONVERSATION_ID:
      return updateCurrentConversationId(state, action);
    case actionTypes.UPDATE_CURRENT_CONVERSATION_ADVERT_ID:
      return updateCurrentConversationAdvertId(state, action);
    case actionTypes.DELETE_CONVERSATIONS_START:
      return deleteConversationStart(state);
    case actionTypes.DELETE_CONVERSATIONS_SUCCESS:
      return deleteConversationSuccess(state, action);
    case actionTypes.DELETE_CONVERSATIONS_FAIL:
      return deleteConversationFailed(state, action);
    case actionTypes.SEND_MESSAGE_START:
      return sendMessageStart(state);
    case actionTypes.SEND_MESSAGE_SUCCESS:
      return sendMessageSuccess(state, action);
    case actionTypes.SEND_MESSAGE_FAIL:
      return sendMessageFailed(state, action);
    case actionTypes.GET_CHAT_FILE_START:
      return getChatFileStart(state);
    case actionTypes.GET_CHAT_FILE_SUCCESS:
      return getChatFileSuccess(state, action);
    case actionTypes.GET_CHAT_FILE_FAIL:
      return getChatFileFailed(state, action);
    case actionTypes.SET_MESSAGE_ID:
      return setMessageId(state, action);
    case actionTypes.CLEAR_MESSAGE_ID:
      return clearMessageId(state);
    default:
      return state;
  }
};

export default chatsReducer;
